import { Icon } from "@iconify/react";
import { Card } from "react-bootstrap";
import packageJson from "../../../../package.json"
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { authenticateUserCredentials } from "../../../api";
import _ from "lodash";
import { checkForAPISuccess } from './../../../Common/commonFunctions';
import { SESSION_STORAGE_AUTH_KEY } from "../../../Common/constants";

const Login = props => {

	const [utils, setUtils] = useState({
		nameOrEmail: "",
		password: "",
		validationMessage: ""
	});

	const authenticateUser = async () => {
		const response = await authenticateUserCredentials({
			userNameOrEmail: utils.nameOrEmail,
			password: utils.password
		});

		return response.data;
	}

	const validateCredentials = () => {
		if(!_.isEmpty(utils.nameOrEmail) && !_.isEmpty(utils.password)) {
			authenticateUserMutation.mutate();
		}
		else {
			setUtils({ ...utils, validationMessage: "Please specify email id and password" })
		}
	}

	const authenticateUserMutation = useMutation(authenticateUser);

	useEffect(() => {
		if(authenticateUserMutation.isSuccess) {
			if(
				checkForAPISuccess(authenticateUserMutation?.data?.statusCode) &&
				authenticateUserMutation?.data?.data?.isValidUser
			) {
				props.authenticateUser();
			}
			else {
				setUtils({ ...utils, validationMessage: "Please provide valid email id and password." });
			}
		}
		else if(authenticateUserMutation.isError) {
			setUtils({ ...utils, validationMessage: "Error during login." });
		}
	}, [authenticateUserMutation.isSuccess, authenticateUserMutation.isError]);

	useEffect(() => {
		if(sessionStorage.getItem(SESSION_STORAGE_AUTH_KEY) === "true") {
			window.location.pathname = window.configs.dashboard_base_path + "/"
		}
	}, []);

	return (
		<div className="auth-wrapper">
			<div className="auth-content">
				<Card>
					<Card.Body className="text-center">
						<div className="mb-4">
							<Icon icon={"feather-unlock"} className="auth-icon text-color-grey" />
						</div>
						<h3 className="mb-4">Login</h3>
						{
							!_.isEmpty(utils.validationMessage) &&
								<div className="mb-3 text-danger">
									<span>{utils.validationMessage}</span>
								</div>
						}
						<div className="input-group mb-3">
							<input
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										validateCredentials()
									}
								}}
								onChange={(e) => setUtils({ ...utils, nameOrEmail: e.target.value })}
								type="text"
								className="form-control blue-box-border text-white-background"
								placeholder="User name / Email"
							/>
						</div>
						<div className="input-group mb-3">
							<input
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										validateCredentials()
									}
								}}
								onChange={(e) => setUtils({ ...utils, password: e.target.value })}
								type="password"
								className="form-control blue-box-border text-white-background"
								placeholder="Password"
							/>
						</div>
						<button onClick={() => validateCredentials()} className="btn btn-primary shadow-2 mb-4 login">
							{
								authenticateUserMutation.isLoading ?
									"Signing In..."
										:
									"Sign In"
							}
						</button>
						<br />
						<div>
							<span className="font-size-x-small">v&nbsp;{packageJson?.version}</span>
						</div>
					</Card.Body>
				</Card>
			</div>
		</div>
	);
};

export default Login;